import { ContentLayout, LoadingScreen } from '@nohara-dxdev/react-core';
import { OidcProtectedComponent, TermsAcceptanceCheck } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';
import { Outlet, useRouteError } from 'react-router';

import { paths } from '@/config/paths';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>;
};

const AppRoot = () => {
  return (
    <OidcProtectedComponent redirectTo={paths.auth.login.path} fallbackElement={<LoadingScreen />}>
      <TermsAcceptanceCheck>
        <Outlet />
      </TermsAcceptanceCheck>
    </OidcProtectedComponent>
  );
};

export default AppRoot;
